module.exports = __webpack_public_path__ + "static/media/template_absences.299e1941.csv";